import { parsePhoneNumberFromString } from 'libphonenumber-js/max'

/**
 * Validates the phone number string, with Singapore specific rules for
 * numbers with the Singapore country code
 * @param phoneNumber
 * @returns true if validate, false otherwise
 */
export const isPhoneNumber = (phoneNumber: string): boolean => {
  const parsedNumber = parsePhoneNumberFromString(phoneNumber)

  if (!parsedNumber) return false

  if (startsWithSgPrefix(phoneNumber)) {
    return (
      parsedNumber.isPossible() &&
      // Regex checks if the national number starts with 3, 6, 8 or 9,
      // and is of length 8.
      !!parsedNumber.nationalNumber.match(/^[3689][0-9]{7}$/g)
    )
  }

  // Not Singapore number, check type and early return if undefined.
  const parsedType = parsedNumber.getType()
  if (!parsedType) return false

  // All other countries uses number type to check for validity.
  return (
    parsedNumber.isPossible() &&
    ['FIXED_LINE', 'FIXED_LINE_OR_MOBILE', 'MOBILE'].includes(parsedType)
  )
}

export const startsWithSgPrefix = (phoneNumber: string): boolean => {
  return phoneNumber.startsWith('+65')
}
